import axiosInstance from './axiosInstance';

const settingService = {
  list: (params = {}) =>
    axiosInstance.get('/admin/settings', { params }),

  getById: (id) =>
    axiosInstance.get(`/admin/settings/${id}`),

  create: (data) =>
    axiosInstance.post('/admin/settings', data),

  update: (id, data) =>
    axiosInstance.put(`/admin/settings/${id}`, data),

  remove: (id) =>
    axiosInstance.delete(`/admin/settings/${id}`),
};

export default settingService;
